import { render, staticRenderFns } from "./Map.vue?vue&type=template&id=60b537af&"
import script from "./Map.vue?vue&type=script&lang=ts&"
export * from "./Map.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports